import { render, staticRenderFns } from "./UserSettingList.vue?vue&type=template&id=4b71e907&scoped=true&"
import script from "./UserSettingList.vue?vue&type=script&lang=js&"
export * from "./UserSettingList.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingList.vue?vue&type=style&index=0&id=4b71e907&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71e907",
  null
  
)

export default component.exports